import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { membershipCancel } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import envVars from '../../../constants/envVars';
const useCancelMembership = () => {
    const queryClient = useQueryClient();
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: (attributes) => axios
            .post(`${envVars.API_COMMERCE_HOSTNAME}subscription/backoffice/cancel`, { ...attributes }, { ...params, timeout: 50000 })
            .then((response) => response),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [membershipCancel] });
        }
    });
};
export default useCancelMembership;
